import template from "./image-selector-modal.html";

const ImageSelectorModalComponent = {
  bindings: {
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class ImageSelectorModalController {
    /* @ngInject */
    constructor($rootScope, $scope, FilePicker, Photo) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.FilePicker = FilePicker;
      this.Photo = Photo;
    }

    async $onInit() {
      this.loading = true;
      this.loadingSelect = false;
      this.serviceUnavailable = false;
      this.noMoreResults = false;
      this.searchOptions = {
        searchText: "",
        orderBy: "latest",
      };
      this.images = [];
      this._setDefaultValues();

      this.$scope.$watch(
        () => this.searchOptions.searchText,
        async (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal)) {
            this.serviceUnavailable = false;
            this._setDefaultValues();
            this.searchOptions.searchText = newVal;
            this.searchOptions.orderBy = "latest";
            if (this.searchOptions.searchText === "") await this.refreshImages();
            else await this.searchPhotos();
          }
        },
      );

      await this.refreshImages();
    }

    async next() {
      if (!this.loading && !this.noMoreResults) {
        this.paginationPage++;
        if (this.searchOptions.searchText.length > 0) await this.searchPhotos();
        else await this.refreshImages();
      }
    }

    async select(imageSelected) {
      this.loadingSelect = true;
      const imageMetadata = await this.FilePicker.uploadSectionUrlImage(imageSelected.urls.regular);
      this.loadingSelect = false;
      if (imageMetadata) {
        this.close({ $value: imageMetadata });
      }
    }

    async refreshImages() {
      this.loading = true;
      try {
        this.images = await this.Photo.listPhotos({
          paginationPage: this.paginationPage,
          photosPerPage: this.photosPerPage,
          orderBy: this.searchOptions.orderBy,
        });
        if (this.images.length === 0) {
          this.loading = false;
          this.noMoreResults = true;
        } else {
          this._setImagesInColum();
          this.loading = false;
          this.$rootScope.$applyAsync();
        }
      } catch (error) {
        if (error.status === 503 && error.data === "Unsplash service temporary unavailable")
          this.serviceUnavailable = true;
        else throw error;
      }
    }

    async listPhotos(orderBy) {
      this.serviceUnavailable = false;
      this._setDefaultValues();
      this.searchOptions.orderBy = orderBy;
      this.searchOptions.searchText = "";
      await this.refreshImages();
    }

    async searchPhotos() {
      this.loading = true;
      try {
        this.images = await this.Photo.searchPhotos({
          searchText: this.searchOptions.searchText,
          paginationPage: this.paginationPage,
          photosPerPage: this.photosPerPage,
        });
        if (this.images.length === 0) {
          this.loading = false;
          this.noMoreResults = true;
        } else {
          this._setImagesInColum();
          this.loading = false;
          this.$rootScope.$applyAsync();
        }
      } catch (error) {
        if (error.status === 503 && error.data === "Unsplash service temporary unavailable")
          this.serviceUnavailable = true;
        else throw error;
      }
    }

    async uploadImage() {
      const imageMetadata = await this.FilePicker.uploadSectionImage();
      if (imageMetadata) this.close({ $value: imageMetadata });
    }

    async reload() {
      this.serviceUnavailable = false;
      this._setDefaultValues();
      if (this.searchOptions.searchText === "") await this.refreshImages();
      else await this.searchPhotos();
    }

    buttonFocus(orderBy) {
      return this.searchOptions.orderBy === orderBy && this.searchOptions.searchText.length === 0;
    }

    cancel() {
      this.dismiss({ $value: "cancel" });
    }

    _setDefaultValues() {
      this.paginationPage = 1;
      this.photosPerPage = 12;
      this.imagesInColum = {
        first: { height: 1, elements: [] },
        second: { height: 2, elements: [] },
        third: { height: 3, elements: [] },
      };
    }

    _setImagesInColum() {
      for (let i = 0; i < this.images.length; i++) {
        if (
          this.imagesInColum.first.height < this.imagesInColum.second.height &&
          this.imagesInColum.first.height < this.imagesInColum.third.height
        ) {
          this.imagesInColum.first.height += this.images[i].height;
          this.imagesInColum.first.elements.push(this.images[i]);
        } else if (
          this.imagesInColum.second.height < this.imagesInColum.first.height &&
          this.imagesInColum.second.height < this.imagesInColum.third.height
        ) {
          this.imagesInColum.second.height += this.images[i].height;
          this.imagesInColum.second.elements.push(this.images[i]);
        } else {
          this.imagesInColum.third.height += this.images[i].height;
          this.imagesInColum.third.elements.push(this.images[i]);
        }
      }
    }
  },
};

export default ImageSelectorModalComponent;
